import {doAssign,accountAssignList,upAssign,checkAssignValidity,batchDelAssign,batchUpAssign } from 'api/accountAssign';
import Cookies from 'js-cookie';

const accAssign = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        //test
        doAssign({commit},params) {
            return new Promise((resolve, reject) => {
                doAssign(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        upAssign({commit},params) {
            return new Promise((resolve, reject) => {
                upAssign(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchUpAssign({commit},params) {
            return new Promise((resolve, reject) => {
                batchUpAssign(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        accountAssignList({commit},params) {
            return new Promise((resolve, reject) => {
                var accountStart = params.accountStart;
                var accountEnd = params.accountEnd;
                var merchant = params.merchant;
                var agent = params.agent;
                var psize = params.psize;
                var currentPage = params.currentPage;
                accountAssignList(accountStart,accountEnd,agent,merchant,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        checkAssignValidity({commit},params) {
            return new Promise((resolve, reject) => {
                checkAssignValidity(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchDelAssign({commit},params) {
            return new Promise((resolve, reject) => {
                batchDelAssign(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default accAssign;



// WEBPACK FOOTER //
// ./src/store/modules/accountAssign.js